import { memo } from "react";
import { useTranslate } from "helpers";
import { CHANNEL_OPTIONS } from "services/api/notifications/consts";
import { ReactSVG } from "react-svg";

interface Props {
  channels: number;
  error?: string;
  onToggle: (channelValue: number) => void;
}

const ChannelSelector: React.FC<Props> = ({ channels, error, onToggle }) => {
  const { t } = useTranslate();

  return (
    <div className="flex-1 mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {t("admin.notification.field.channels")} <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-3 gap-2">
        {CHANNEL_OPTIONS.map((ch) => {
          const isActive = !!(channels & ch.value);
          return (
            <button
              key={ch.value}
              type="button"
              onClick={() => onToggle(ch.value)}
              className={`flex items-center gap-2 py-4 px-4 rounded-sm border transition-all cursor-pointer ${
                isActive
                  ? "border-amber-600 bg-amber-50 shadow-sm"
                  : error
                    ? "border-red-300 bg-red-50 hover:border-red-400"
                    : "border-slate-300 bg-white hover:border-gray-300 hover:bg-gray-50"
              }`}
            >
              <ReactSVG
                src={ch.icon}
                className={`w-6 h-6 [&_svg]:stroke-current ${isActive ? "text-amber-600" : "text-gray-600"}`}
              />
              <span className={`text-sm font-medium flex-1 ${isActive ? "text-amber-700" : "text-gray-800"}`}>
                {ch.label}
              </span>
              {isActive && (
                <svg className="w-4 h-4 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </button>
          );
        })}
      </div>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

export default memo(ChannelSelector);
